import React from "react"
import "../scss/old-pages.scss"

const NewsletterWidget = () => {
  return (
    <div className="newsletter-widget">
      <h3>
        The Aider Monthly<span className="text-teal dot">.</span>
      </h3>
      <p>
        Sign up to receive tips on how to get insights from your business data
        and turn these useful truths into data-led action. (We only email
        once-per-month!)
      </p>
    </div>
  )
}

export default NewsletterWidget
